import React from "react";

// @material-ui/core
// core components
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import Card from '@mui/material/Card';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import { useQuery } from "react-query";
import { useToken } from "hooks/token.js";
import { useAxiosAuth } from "hooks/axios.js";
import { ExternalLink } from 'react-external-link';

import axios from "axios";
import { getApiCall } from "hooks/axios";

export default function Apps() {
  const url = "/api/v1/apps"
  const [token, setToken] = useToken();
  useAxiosAuth(token);
  localStorage.setItem('tabsValue', 1);
  const { isLoading, error, data } = useQuery(
    "app", 
    async () => {
      const data = await getApiCall(url, {
        onError: (error) => {} 
      });
      if(data.hasOwnProperty('items') && data.items.length > 0) {
        return data.items;
      }
    },
  )

  const appData = (data) => {
    let rows = [];
    if (data && data.length > 0) {
      let partsf = data[0].name.split(".");
      data.push({name: partsf.slice(1).join(".")});

      data.forEach((item) => {
            let link = "https://" + item.name
            let parts = item.name.split(".")
            let iconURI = "/" + parts[0] + ".png"

            rows.push(
                  <Grid item xs={6} sm={4} md={3} lg={2}>
                    <Button component={ExternalLink} href={link} sx={{ width: 1, padding: "0px !important" }}>
                      <Paper sx={{ width: 1 }}>
                        
                        <MDBox sx={{ padding: "20%", paddingBottom: "0px"}}>
                          <img
                            width="100%"
                            height="auto"
                            src={iconURI}
                            onError={event => {
                              event.target.src = "/generic.png"
                              event.onerror = null
                            }}
                          />
                        </MDBox>

                        <Typography
                          sx={{ margin: "7% !important", fontWeight: "bold !important", fontSize: "min(0.65rem, 100%) !important" }}
                          component="div"
                        >
                          {parts[0]}
                        </Typography>

                      </Paper>
                    </Button>
                  </Grid>
            )
          }
      )
    }

    return rows;
  }

  return (
    <div>
        <Grid
          container
          maxWidth="md"
          spacing={3}
          alignItems="center"
        >
          { appData(data) }
        </Grid>
    </div>
  );
}
